// ** Reactstrap Imports
import { Row, Col, Card, CardBody, CardTitle, CardText } from 'reactstrap';

const AccessControl = () => {
  // ** Context
  return (
    <Row>
      <Col md="6" sm="12">
        <Card>
          <CardBody>
            <CardTitle tag="h4">Centro de control</CardTitle>
            <CardText className="text-primary">
              Selecciona una opcion del menu para navegar por el panel
            </CardText>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default AccessControl;
